import { api } from "@/lib/api";

const CHUNK_SIZE = 4 * 1024 * 1024;

export async function uploadMedia(file, onProgress) {
  const uploadId =
    window.crypto?.randomUUID?.() || `u${Date.now()}${Math.random().toString(36).slice(2)}`;
  const chunks = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));

  for (let i = 0; i < chunks; i += 1) {
    const body = new FormData();
    body.append("upload_id", uploadId);
    body.append("index", String(i));
    body.append("chunk", file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE), file.name);
    await api.post("/admin/media/chunk", body);
    if (onProgress) onProgress(Math.round(((i + 1) / chunks) * 95));
  }

  const done = new FormData();
  done.append("upload_id", uploadId);
  done.append("filename", file.name);
  const { data } = await api.post("/admin/media/complete", done);
  if (onProgress) onProgress(100);
  return data;
}

export function formatBytes(bytes) {
  if (!bytes) return "";
  const units = ["B", "KB", "MB", "GB"];
  let n = bytes;
  let u = 0;
  while (n >= 1024 && u < units.length - 1) {
    n /= 1024;
    u += 1;
  }
  return `${n.toFixed(n < 10 && u > 0 ? 1 : 0)} ${units[u]}`;
}
